import { Typography } from '@mui/material';
import { DirectionIcon, NotificationTextIcon, Tool01Icon } from '../../../assets/images';
import { dateFormate } from '../../../utils/utils';
import { MuiStack } from '../../atoms/stackComponent';
//Service details card
export default function ServiceDetailsCard(props) {
    var data = props.data;
    return /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: 'row',
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        id: "job-type",
        style: {
            textTransform: 'capitalize'
        }
    }, data !== null && data !== void 0 && data.JobType ? data === null || data === void 0 ? void 0 : data.JobType : '-'), /*#__PURE__*/ React.createElement(Typography, {
        style: {
            fontSize: '12px',
            fontWeight: '500',
            color: '#8593A3'
        },
        id: "usage-rading"
    }, data !== null && data !== void 0 && data.UsageReading ? data === null || data === void 0 ? void 0 : data.UsageReading : '-', " KM")), /*#__PURE__*/ React.createElement(MuiStack, {
        paddingX: 1,
        paddingY: 1.5,
        spacing: 1.5,
        direction: "column",
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: '8px',
            marginTop: 2
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        paddingX: 1,
        paddingY: 0.5,
        spacing: 1.5,
        direction: "column",
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        style: {
            fontSize: '12px',
            fontWeight: '500'
        },
        id: "jobcard"
    }, data !== null && data !== void 0 && data.JobCard ? data === null || data === void 0 ? void 0 : data.JobCard : '-')), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        id: "doc-date"
    }, data !== null && data !== void 0 && data.DocDate ? dateFormate(data === null || data === void 0 ? void 0 : data.DocDate) : '-')), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1
    }, /*#__PURE__*/ React.createElement("img", {
        src: DirectionIcon
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: '#8593A3',
        id: "branch-name"
    }, data !== null && data !== void 0 && data.BranchName ? data === null || data === void 0 ? void 0 : data.BranchName : '-')), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1
    }, /*#__PURE__*/ React.createElement("img", {
        src: NotificationTextIcon
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: '#8593A3',
        id: "service-advisor-name"
    }, data !== null && data !== void 0 && data.ServiceAdvisorName ? data === null || data === void 0 ? void 0 : data.ServiceAdvisorName : '-')), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1
    }, /*#__PURE__*/ React.createElement("img", {
        src: Tool01Icon
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: '#8593A3',
        id: "mechanic-name"
    }, data !== null && data !== void 0 && data.MechanicName ? data === null || data === void 0 ? void 0 : data.MechanicName : '-'))));
}
